import React, { useEffect, useState } from "react";
import "./success.css";
import { Link, useNavigate } from "react-router-dom";
import succesImg from "../../Assets/Payment_Assets/success_illustration.png";

const Success = () => {
  const navigate = useNavigate();
  const [isJuridentPayment, setIsJuridentPayment] = useState(false);
  const [redirecting, setRedirecting] = useState(true);

  useEffect(() => {
    console.log('🔍 [Success Page] Checking payment type...');

    // Check localStorage for Jurident payment context
    const paymentContextStr = localStorage.getItem('jurident_payment_context');

    if (paymentContextStr) {
      try {
        const paymentContext = JSON.parse(paymentContextStr);
        console.log('📦 [Success Page] Found Jurident payment context in localStorage:', paymentContext);

        // Verify this is a recent payment (within last 30 minutes)
        const ageMinutes = (Date.now() - paymentContext.timestamp) / 1000 / 60;
        console.log('⏱️  [Success Page] Payment context age:', Math.round(ageMinutes), 'minutes');

        if (ageMinutes < 30) {
          console.log('✅ [Success Page] Valid Jurident payment detected, redirecting...');
          setIsJuridentPayment(true);

          // Build redirect URL with payment data
          const params = new URLSearchParams({
            userId: paymentContext.userId,
            transactionId: paymentContext.transactionId,
            amount: paymentContext.amount,
            category: paymentContext.category,
            phoneNo: paymentContext.phoneNo,
            userName: paymentContext.userName || 'User',
            platform: paymentContext.platform
          });

          const juridentSuccessUrl = `/jurident-payment/success?${params.toString()}`;
          console.log('🔄 [Success Page] Redirecting to:', juridentSuccessUrl);

          // Clean up localStorage
          localStorage.removeItem('jurident_payment_context');
          console.log('🧹 [Success Page] Cleaned up payment context from localStorage');

          // Redirect after a brief moment
          setTimeout(() => {
            navigate(juridentSuccessUrl);
          }, 500);

          return;
        } else {
          console.log('⚠️  [Success Page] Payment context expired, cleaning up...');
          localStorage.removeItem('jurident_payment_context');
        }
      } catch (error) {
        console.error('❌ [Success Page] Error parsing payment context:', error);
        localStorage.removeItem('jurident_payment_context');
      }
    }

    // Fallback: Check URL parameters for transaction ID
    const params = new URLSearchParams(window.location.search);
    const transactionId = params.get('transactionId') || params.get('merchantTransactionId');

    console.log('🔍 [Success Page] Checking URL parameters...');
    console.log('Transaction ID from URL:', transactionId);

    // Jurident transaction IDs start with 'T' followed by timestamp
    if (transactionId && transactionId.startsWith('T') && transactionId.length > 10) {
      console.log('✅ [Success Page] Detected Jurident payment from URL, redirecting...');
      setIsJuridentPayment(true);

      // Get all URL parameters to forward them
      const urlParams = window.location.search;

      // Redirect to Jurident success page with all parameters
      const juridentSuccessUrl = `/jurident-payment/success${urlParams}`;
      console.log('🔄 [Success Page] Redirecting to:', juridentSuccessUrl);

      // Redirect after a brief moment
      setTimeout(() => {
        navigate(juridentSuccessUrl);
      }, 500);
    } else {
      console.log('✅ [Success Page] Regular course/WhatsApp payment');
      setRedirecting(false);
    }
  }, [navigate]);

  // Show loading state while redirecting
  if (isJuridentPayment && redirecting) {
    return (
      <section className="payment_container">
        <h1>Payment Successful! ✅</h1>
        <h2>Redirecting to your subscription page...</h2>
        <div className="illustation_container">
          <div style={{
            width: '50px',
            height: '50px',
            border: '4px solid #f3f3f3',
            borderTop: '4px solid #4caf50',
            borderRadius: '50%',
            animation: 'spin 1s linear infinite',
            margin: '20px auto'
          }}></div>
        </div>
      </section>
    );
  }

  // Regular course/WhatsApp payment success page
  return (
    <>
      <section className="payment_container">
        <h1>Congratulations 🎉</h1>
        <h2>
          Course Purchased Successfully! <br />
          -- For Further Updates --
        </h2>
        <div className="illustation_container">
          <img src={succesImg} alt="Error in loading illustration" />
        </div>
        <a href="https://chat.whatsapp.com/J8hDrhp50Q570ICUaChfad">
          Join Whatsapp
        </a>
        <br></br>
         <Link to="/Courses">Back to Courses</Link>
      </section>
    </>
  );
};

export default Success;
